import { useTranslations } from 'next-intl';
import { observer, inject } from 'mobx-react';
import CloseOneIcon from '../svg/CloseOneIcon';
import ButtonWithLoading from '../form-fields/ButtonWithLoading';

const DeleteAccountModal = inject('studioStore')(observer(({ studioStore, onConfirm, onCancel, onClose }) => {
  const t = useTranslations('Account');

  const container = studioStore.settings.product_popup?.container;
  const productInfoBackgroundColor = studioStore.settings.product_popup?.product_info_background_color;
  const primaryColor = studioStore.settings.colors.primary_color;

  let classes = "fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-2xl md:mx-auto max-h-[90vh] z-50";
  const style = {
    backgroundColor: productInfoBackgroundColor,
  };

  if (container === "stamp") {
    classes = classes + " stamp-border";
    style.backgroundImage = `radial-gradient(8px, transparent 98%, ${productInfoBackgroundColor}),linear-gradient(${productInfoBackgroundColor} 0px, ${productInfoBackgroundColor} 0px)`;
    style.backgroundColor = '';
  } else {
    classes = classes + " rounded-lg shadow-lg p-4 bg-white";
  }

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="fixed inset-0 transition-opacity" aria-hidden="true">
        <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
      </div>

      <div className={classes} style={style}>
        <button
          className="absolute top-4 md:-top-8 left-4 md:-left-10 rtl:right-4 rtl:md:-right-10 rtl:left-auto z-10"
          onClick={onClose}
        >
          <CloseOneIcon size="28px" stroke={primaryColor} />
        </button>

        <div className="max-h-[86vh] overflow-y-auto">
          <div className="p-3 md:p-6">
            <div className="px-4 md:px-12">
              <div className="text-center">
                <h2 className="mt-3 mb-6 text-2xl font-semibold text-primary-studio" data-testid="delete-account-title">
                  {t('delete_account_title')}
                </h2>
                <p className="text-lg text-secondary-text-studio mb-8" data-testid="delete-account-message">
                  {t('delete_account_message')}
                </p>
                <div className="flex justify-center gap-4">
                  <ButtonWithLoading
                    type="button"
                    variant="error"
                    text={t('delete_account_confirm')}
                    onClick={onConfirm}
                    data-testid="confirm-delete-account"
                  />
                  <ButtonWithLoading
                    type="button"
                    variant="success"
                    text={t('keep_account')}
                    onClick={onCancel}
                    data-testid="keep-account"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}));

export default DeleteAccountModal;